import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AppSettings } from '../../app.settings';
import { ActiveEmployerCompanyService } from '../../services/active-employer-company/active-employer-company.service';
import { TeamManagerWorkspaceService } from '../../services/team-manager-workspace/team-manager-workspace.service';
import { SessionService } from '../../services/session/session.service';
import { CompanyOffersAccessService } from '../../services/company-offers/company-offers-access.service';

@Injectable({ providedIn: 'root' })
export class CompanyOffersGuard implements CanActivate {
  constructor(
    private company: ActiveEmployerCompanyService, private teams: TeamManagerWorkspaceService,
    private session: SessionService, private router: Router, private access: CompanyOffersAccessService,
  ) {}
  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    if (this.session.isTeamAgentSession() || AppSettings.isPayrollAdmin() || AppSettings.isBroker()
      || AppSettings.isContentAdmin() || AppSettings.isCustomerSupport() || AppSettings.isIntegration() || AppSettings.isFinance()) {
      return this.router.parseUrl('/');
    }
    if (this.session.isExactSuperAdmin() && route.queryParams.workspace === 'company' && route.queryParams.companyId) {
      const companyId = `${route.queryParams.companyId}`.trim();
      await this.company.initializeScopedSuperadminCompany(companyId);
      return this.company.isScopedSuperadminCompanyWorkspaceActive()
        && this.company.activeCompany?.id === companyId
        && await this.access.isEnabled(undefined, true) || this.router.parseUrl('/');
    }
    await this.company.initialize();
    if (this.company.isSupportedSingleCompanyWorkspaceActive()) {
      return await this.access.isEnabled(undefined, true) || this.router.parseUrl('/');
    }
    const state = await this.teams.refresh();
    if (!state.enabled) { return this.router.parseUrl('/'); }
    const team = await this.teams.ensureSelectedTeam();
    return !!team && this.teams.state.enabled && await this.access.isEnabled(undefined, true) || this.router.parseUrl('/');
  }
}
